module.exports = __webpack_public_path__ + "img/sign.2f910933.svg";